import MuiCheckbox from '@material-ui/core/Checkbox';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { HIGHLIGHT, TEXT } from '../Colors';
import { BODY } from '../Fonts';
import { Icon } from '../Icon';
import { DASH, TICK } from '../Svgs';

const StyledFormControlLabel = withStyles({
    root: {
        marginLeft: '-9px',
        marginRight: '9px',
        '&>.MuiFormControlLabel-label': {
            font: BODY,
            marginBottom: '2px'
        },
    },
})(MuiFormControlLabel);

const StyledCheckbox = withStyles({
    root: {
        color: TEXT,
        '&>.MuiIconButton-label': {
            border: '2px solid white',
            borderRadius: '4px',
            width: '16px',
            height: '16px'
        },
        '&.Mui-checked': {
            '&>.MuiIconButton-label': {
                backgroundColor: HIGHLIGHT,
                color: TEXT,
                border: '1px solid white',
                width: '18px',
                height: '18px'
            },
        }
    },
})(MuiCheckbox);

const useStyles = makeStyles({
    hidden: {
        display: 'none',
    }
});

interface CheckboxProps {
    checked: boolean | "indeterminate" | Array<boolean | "indeterminate">,
    hidden?: boolean,
    label?: string,
    disabled?: boolean,
    autoFocus?: boolean,
    stopPropagation?: boolean,
    onChange?(isChecked: boolean): void
}

export const Checkbox: React.FunctionComponent<CheckboxProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const isChecked = Array.isArray(props.checked) ? (props.checked.includes(true) ? true : false) : (props.checked !== false);
    const isIndeterminate = Array.isArray(props.checked) ?
        props.checked.every(a => a === true) || props.checked.every(a => a === false) ? false :
            (props.checked.includes(false) || props.checked.includes("indeterminate") ? true : false) :
        (props.checked === "indeterminate");

    const onChange = (checked) => {
        if (props.onChange) {
            if (isIndeterminate) {
                props.onChange(true);
            } else {
                props.onChange(checked);
            }
        }
    }

    const className = `${props.hidden ? classes.hidden : ''}  ${stylingClassName}`;

    return (
        <StyledFormControlLabel disabled={props.disabled} className={className}
            control={
                <StyledCheckbox
                    checked={isChecked}
                    indeterminate={isIndeterminate}
                    onClick={e => { if (props.stopPropagation) e.stopPropagation(); }}
                    onChange={e => onChange(e.target.checked)}
                    autoFocus={props.autoFocus}
                    color="primary"
                    icon={<Icon />}
                    indeterminateIcon={<Icon>{DASH}</Icon>}
                    checkedIcon={<Icon>{TICK}</Icon>}
                />
            }
            label={props.label}
        />);
}